export const all_access = [
    { value: "1A"  , label: 'Pro' },  // FE 1
    { value: "1B"  , label: 'Fe B' },  // FE 2
    { value: "1ds" , label: 'Fe Ds' }, // FE Down Sell
    { value: "1a"  , label: 'FastPass Offer' }, // FE Bump 1
    { value: "1b"  , label: 'Masterclass' }, // FE Bump 2
    { value: "1c"  , label: 'Cold Reachout Templates' }, // FE Bump 3

    { value: "2A"  , label: 'Platinum'}, // OTO1 1
    { value: "2B"  , label: 'OTO-1B'}, // OTO1 2
    { value: "2ds"  , label: 'OTO-1 Ds'}, // OTO1 Down Sell
    { value: "2a"  , label: 'Lower Third Templates'}, // OTO1 Bump 1
    { value: "2b"  , label: 'OTO-1 BUMP-2'},  // OTO1 Bump 2
    { value: "2c"  , label: 'OTO-1 BUMP-3'},  // OTO1 Bump 3

    { value: "3A" , label: 'Template Club'}, // OTO2 1
    { value: "3B" , label: 'OTO-2B'}, // OTO2 2
    { value: "3ds" , label: 'OTO-2 Ds'}, // OTO2 Down Sell
    { value: "3a" , label: 'OTO-2 BUMP-1'}, // OTO2 Bump 1
    { value: "3b" , label: 'OTO-2 BUMP-2'}, // OTO2 Bump 2
    { value: "3c" , label: 'OTO-2 BUMP-3'}, // OTO2 Bump 3
    
    { value: "4A" , label: 'Masterclass'}, // OTO3 1
    { value: "4B" , label: 'OTO-3B'}, // OTO3 2
    { value: "4ds" , label: 'OTO-3 Ds'}, // OTO3 Down Sell
    { value: "4a" , label: 'OTO-3 BUMP-1'}, // OTO3 Bump 1
    { value: "4b" , label: 'OTO-3 BUMP-2'}, // OTO3 Bump 2
    { value: "4c" , label: 'OTO-3 BUMP-3'}, // OTO3 Bump 3

    { value: "5" , label: "Super Admin"}, // Super Admin
    
    { value: "6A" , label: 'LeadCraft AI - (Client Finder)'}, // OTO4 1
    { value: "6B" , label: 'OTO-4B'}, // OTO4 2
    { value: "6ds" , label: 'OTO-4 Ds'}, // OTO4 Down Sell
    { value: "6a" , label: 'OTO-4 BUMP-1'}, // OTO4 Bump 1
    { value: "6b" , label: 'OTO-4 BUMP-2'}, // OTO4 Bump 2
    { value: "6c" , label: 'OTO-4 BUMP-3'}, // OTO4 Bump 3

    { value: "7A" , label: 'Agency'}, // OTO5 1
    { value: "7B" , label: 'OTO-5B'}, // OTO5 2
    { value: "7ds" , label: 'OTO-5 Ds'}, // OTO5 Down Sell
    { value: "7a" , label: 'OTO-5 BUMP-1'}, // OTO5 Bump 1
    { value: "7b" , label: 'OTO-5 BUMP-2'}, // OTO5 Bump 2
    { value: "7c" , label: 'OTO-5 BUMP-3'}, // OTO5 Bump 3

    { value: "10A" , label: 'OTO-6A'}, // OTO6 1
    { value: "10B" , label: 'OTO-6B'}, // OTO6 2
    { value: "10ds" , label: 'OTO-6 Ds'}, // OTO6 Down Sell
    { value: "10a" , label: 'OTO-6 BUMP-1'},  // OTO6 Bump 1  
    { value: "10b" , label: 'OTO-6 BUMP-2'}, // OTO6 Bump 2
    { value: "10c" , label: 'OTO-6 BUMP-3'}, // OTO6 Bump 3
 
    { value: "11A" , label: 'OTO-7A'}, // OTO7 1
    { value: "11B" , label: 'OTO-7B'}, // OTO7 2
    { value: "11ds" , label: 'OTO-7 Ds'}, // OTO7 Down Sell
    { value: "11a" , label: 'OTO-7 BUMP-1'}, // OTO7 Bump 1
    { value: "11b" , label: 'OTO-7 BUMP-2'}, // OTO7 Bump 2
    { value: "11c" , label: 'OTO-7 BUMP-3'}, // OTO7 Bump 3
    
    { value: "8" , label: 'Bundle'}, // Bundle
    { value: "8A" , label: 'Ultimate Bundle Offer'}, // Bundle without template club
    { value: "8B" , label: 'Ultimate Bundle Offer + Elite Template Club'}, // Bundle with template club
    { value: "8SB" , label: 'Super Bundle + 2 Years of Elite Template Club Membership'}, // Super Bundle with 2 years template club
    { value: "8M" , label: 'Mega Bundle'}, // Mega Bundle 
    { value: "8SP" , label: 'Bundle Split Payment Option'}, // Bundle Split Payment Option
    { value: "8P" , label: 'Platinum Bundle'}, // Platinum Bundle
    { value: "8a" , label: "VidAmaze Agency Setup"}, // VidAmaze Agency Setup
    { value: "8b" , label: "VidAmaze 1000 Credits"}, // VidAmaze 1000 Credits
    { value: "9S" , label: "Template Management"}, //  Template Management
    { value: "91" , label: "JV Access"}, // JV Access
]